/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/__root'
import { Route as ReportsRouteImport } from './../../pages/reports'
import { Route as MeetingsRouteImport } from './../../pages/meetings'
import { Route as LoginRouteImport } from './../../pages/login'
import { Route as IndexRouteImport } from './../../pages/index'
import { Route as RoomIdRouteImport } from './../../pages/room.$id'
import { Route as MyMeetingsRouteImport } from './../../pages/my.meetings'
import { Route as MeetingsIdRouteImport } from './../../pages/meetings_.$id'
import { Route as JoinIdRouteImport } from './../../pages/join.$id'
import { Route as GuestTokenRouteImport } from './../../pages/guest.$token'
import { Route as MyMeetingsIdRouteImport } from './../../pages/my.meetings_.$id'

const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const MeetingsRoute = MeetingsRouteImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomIdRoute = RoomIdRouteImport.update({
  id: '/room/$id',
  path: '/room/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MyMeetingsRoute = MyMeetingsRouteImport.update({
  id: '/my/meetings',
  path: '/my/meetings',
  getParentRoute: () => rootRouteImport,
} as any)
const MeetingsIdRoute = MeetingsIdRouteImport.update({
  id: '/meetings_/$id',
  path: '/meetings/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinIdRoute = JoinIdRouteImport.update({
  id: '/join/$id',
  path: '/join/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestTokenRoute = GuestTokenRouteImport.update({
  id: '/guest/$token',
  path: '/guest/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const MyMeetingsIdRoute = MyMeetingsIdRouteImport.update({
  id: '/my/meetings_/$id',
  path: '/my/meetings/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/meetings': typeof MeetingsRoute
  '/reports': typeof ReportsRoute
  '/guest/$token': typeof GuestTokenRoute
  '/join/$id': typeof JoinIdRoute
  '/meetings/$id': typeof MeetingsIdRoute
  '/my/meetings': typeof MyMeetingsRoute
  '/room/$id': typeof RoomIdRoute
  '/my/meetings/$id': typeof MyMeetingsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/meetings': typeof MeetingsRoute
  '/reports': typeof ReportsRoute
  '/guest/$token': typeof GuestTokenRoute
  '/join/$id': typeof JoinIdRoute
  '/meetings/$id': typeof MeetingsIdRoute
  '/my/meetings': typeof MyMeetingsRoute
  '/room/$id': typeof RoomIdRoute
  '/my/meetings/$id': typeof MyMeetingsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/meetings': typeof MeetingsRoute
  '/reports': typeof ReportsRoute
  '/guest/$token': typeof GuestTokenRoute
  '/join/$id': typeof JoinIdRoute
  '/meetings_/$id': typeof MeetingsIdRoute
  '/my/meetings': typeof MyMeetingsRoute
  '/room/$id': typeof RoomIdRoute
  '/my/meetings_/$id': typeof MyMeetingsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/meetings'
    | '/reports'
    | '/guest/$token'
    | '/join/$id'
    | '/meetings/$id'
    | '/my/meetings'
    | '/room/$id'
    | '/my/meetings/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/meetings'
    | '/reports'
    | '/guest/$token'
    | '/join/$id'
    | '/meetings/$id'
    | '/my/meetings'
    | '/room/$id'
    | '/my/meetings/$id'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/meetings'
    | '/reports'
    | '/guest/$token'
    | '/join/$id'
    | '/meetings_/$id'
    | '/my/meetings'
    | '/room/$id'
    | '/my/meetings_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  MeetingsRoute: typeof MeetingsRoute
  ReportsRoute: typeof ReportsRoute
  GuestTokenRoute: typeof GuestTokenRoute
  JoinIdRoute: typeof JoinIdRoute
  MeetingsIdRoute: typeof MeetingsIdRoute
  MyMeetingsRoute: typeof MyMeetingsRoute
  RoomIdRoute: typeof RoomIdRoute
  MyMeetingsIdRoute: typeof MyMeetingsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meetings': {
      id: '/meetings'
      path: '/meetings'
      fullPath: '/meetings'
      preLoaderRoute: typeof MeetingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/room/$id': {
      id: '/room/$id'
      path: '/room/$id'
      fullPath: '/room/$id'
      preLoaderRoute: typeof RoomIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/meetings': {
      id: '/my/meetings'
      path: '/my/meetings'
      fullPath: '/my/meetings'
      preLoaderRoute: typeof MyMeetingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meetings_/$id': {
      id: '/meetings_/$id'
      path: '/meetings/$id'
      fullPath: '/meetings/$id'
      preLoaderRoute: typeof MeetingsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$id': {
      id: '/join/$id'
      path: '/join/$id'
      fullPath: '/join/$id'
      preLoaderRoute: typeof JoinIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guest/$token': {
      id: '/guest/$token'
      path: '/guest/$token'
      fullPath: '/guest/$token'
      preLoaderRoute: typeof GuestTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/meetings_/$id': {
      id: '/my/meetings_/$id'
      path: '/my/meetings/$id'
      fullPath: '/my/meetings/$id'
      preLoaderRoute: typeof MyMeetingsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  MeetingsRoute: MeetingsRoute,
  ReportsRoute: ReportsRoute,
  GuestTokenRoute: GuestTokenRoute,
  JoinIdRoute: JoinIdRoute,
  MeetingsIdRoute: MeetingsIdRoute,
  MyMeetingsRoute: MyMeetingsRoute,
  RoomIdRoute: RoomIdRoute,
  MyMeetingsIdRoute: MyMeetingsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
